<template>
  <div class="continue-bar">
    <div class="probot-chat">
      <LazyImage :url="require('../../assets/probot-avatar.svg')" />
      <p class="speech"><VueTyper :text="text" :repeat="0" /></p>
    </div>
    <Btn
      primary
      :isLoading="btnLoading"
      @click="goToLink(link)"
      :tooltip="hint">
      {{ buttonText }}
    </Btn>
  </div>
</template>

<script>
import {VueTyper} from 'vue-typer'
import Btn from '@/components/Btn'
import LazyImage from '@/components/LazyImage'

export default {
  name: 'probot-chat',

  props: ['text', 'buttonText', 'hint', 'link', 'btnLoading'],

  components: {
    VueTyper,
    LazyImage,
    Btn
  },

  methods: {
    goToLink(link) {
      this.$router.push(link)
    }
  }
}
</script>

<style lang="sass">
@import '../../stylesheets/base/variables'
@import '../../stylesheets/helpers/mixins'
@import '../../stylesheets/helpers/extends'

.continue-bar
  position: fixed
  bottom: 0
  left: 0
  background: #fff
  box-shadow: 5px 0 10px rgba(0, 0, 0, 0.15)
  width: 100%
  left: 0
  padding: $gap-small $gap-medium
  display: flex
  justify-content: space-between
  align-items: center

  .speech
    background: rgba(0, 0, 0, 0.03)
    padding: 5px 10px
    border-radius: 10px

  @include media($media-gt-medium)
    width: 75%
    left: 25%

  .builder-tip
    transform: translate(-50%, -50px)!important
    width: 160px!important

  .btn
    &:hover
      .builder-tip
        transform: translate(-50%, -60px)!important

.probot-chat
  display: flex
  align-items: center

  .lazy-image
    max-width: 50px
    max-height: 50px
    border-radius: 50%
    padding: 7px 8px 3px 8px
    margin-right: $gap-small

    @include themify($themes)
      background: themed('color-tertiary')
</style>
